import {StandardUserRemoval} from 'app/services/standard-user-removal';
import {StandardFamiliarizationUser} from 'app/models/standard-user.model';
import {HttpErrorResponse} from '@angular/common/http';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/concatMap';
import {Standard} from 'app/models/standard.model';
import {isStandardVersionConflict, savedStandardVersion} from 'app/services/standard-version';
const DEFAULT_TESTING_DAYS = 5;
const STANDARD_QUESTION_LANGUAGE_RUSSIAN = 'russian';
const STANDARD_QUESTION_LANGUAGE_ENGLISH = 'english';
const TESTING_STEP = 7;
const STANDARD_VERSION_FIELD = 'version';
const RELOAD_HTTP_OK = 200;
import {Component, OnDestroy, OnInit} from '@angular/core';
import {StepsControllerService} from '../../../../services/steps-controller.service';
import * as moment from 'moment';
import {StepTestingService} from './step-create-testing/step-testing.service';
import {StepConfirmPopupComponent} from '../step-confirm-popup/step-confirm-popup.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../../services/admin.service';
import {NewBlank} from '../../../../models/new-blank.model';
import {ConfirmationPopupComponent} from '../../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import {UserService} from '../../../../services/user.service';
import {ApiConnectService} from '../../../../services/api-connect.service';
import {log} from 'util';
import {ViewDocxComponent} from '../../../views/view-docx/view-docx.component';
import {ViewDocxService} from '../../../../services/view-docx.service';

@Component({
  selector: 'app-opst-step-six',
  templateUrl: './opst-step-six.component.html',
  styleUrls: ['./opst-step-six.component.css']
})
export class OpstStepSixComponent implements OnInit, OnDestroy {
  userRemoval = new StandardUserRemoval(this.adminService, this.modalService);

  versionConflict = false;
  saveFailed = false;
  reloadFailed = false;
  private readonly destroyed$ = new Subject<void>();
  showTestingStart = false;
  noQValid = false;
  thisStandard: any;
  usersAndGroups: any;
  stringDate: string;
  daysForTesting = 5;
  daysForTestingTemp = null;
  showTestingBtn = false;
  goToSeven = false;
  showTable = false;
  isReadOnly = false;

  goBtnIsClicked = false;
  isLoaded = false;
  isLoadedStep = false;
  tableUsers: any;

  showAddUser = false;
  showCreateTesting = true;
  showChangeLog = false;
  showUserTable = false;
  showFilesAndBlanks = false;

  // RUS
  isNewRuDoc = false;
  isNewRuPpt = false;
  isNewRuPdf = false;
  fileRuDoc: File = null;
  fileRuPpt: File = null;
  fileRuPdf: File = null;
  // ENG
  isNewEnDoc = false;
  isNewEnPpt = false;
  isNewEnPdf = false;
  fileEnDoc: File = null;
  fileEnPpt: File = null;
  fileEnPdf: File = null;

  isUploadDisabled = false;
  newBlanks: NewBlank[] = [];

  constructor(public stepsControllerService: StepsControllerService,
              public stepTestingService: StepTestingService,
              private modalService: NgbModal,
              public viewDocxService: ViewDocxService,
              private adminService: AdminService,
              private apiConnectService: ApiConnectService,
              private userService: UserService) {
  }

  ngOnInit() {
    this.isLoadedStep = false;
    this.stringDate = moment().format('DD.MM.YYYY');
    this.thisStandard = this.stepsControllerService.getCurrentStandard();

    if (this.thisStandard.englishQuestions !== null && this.thisStandard.englishQuestions.length > 0) {
      this.stepTestingService.addExistingQuestuins(this.thisStandard.englishQuestions, this.thisStandard.russianQuestions);
    }

    if (this.thisStandard.status === 'ACTIVE') {
      this.showTestingStart = true;
    }
    if (this.stepsControllerService.getCurrentStandard().readyForTestingStage) {
      this.goToSeven = true;
      this.showTestingBtn = true;
    } else {
      this.goToSeven = false;
      this.showTestingBtn = false;
    }
    if (this.thisStandard.readyForTestingStage && this.thisStandard.status === 'UNDER_FAMILIARIZATION') {
      this.showTestingBtn = true;
      this.isReadOnly = false;
    }
    this.getUserTable();
  }

  onChange() {
    if (this.daysForTesting < 1) {
      this.daysForTesting = 1;
    }
  }

  getUserTable() {
    this.isLoaded = false;
    this.isLoadedStep = false;
    // Get familiarize info:
    this.stepsControllerService.getFamiliarizedInfo(this.stepsControllerService.getCurrentStandard().id).subscribe(
      (response) => {
        if (response.status === 200) {
          this.tableUsers = response.body;
          this.showTable = true;
          this.isLoaded = true;
          this.isLoadedStep = true;
          this.thisStandard.status = this.stepsControllerService.getCurrentStandard().status.toString();

          let counters = 0;
          this.tableUsers.forEach(item => {
            if (item.testingDate === '') {
              counters++;
            }
          });
          if (counters > 0) {
            this.goToSeven = true;
            this.showTestingStart = false;
          }
        }
      },
      () => {
        this.isLoaded = true;
        this.isLoadedStep = true;
      }
    );
  }

  uploadFile(typeFile) {
    this.isUploadDisabled = true;
    if (typeFile === 'RU_PPT') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileRuPpt, this.fileRuPpt.name);


      this.adminService.uploadFiles(this.stepsControllerService.getCurrentStandard(), formData).subscribe(
        (res: any) => {
          this.adminService.getStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
            (response: any) => {
              this.thisStandard.ruPpt = response.body.ruPpt;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );

        },
        () => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'RU_DOC') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileRuDoc, this.fileRuDoc.name);
      this.adminService.uploadFiles(this.stepsControllerService.getCurrentStandard(), formData).subscribe(
        () => {
          this.adminService.getStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
            (response: any) => {
              this.thisStandard.ruDoc = response.body.ruDoc; // F+
              this.thisStandard.ruPdf = response.body.ruPdf; // F+
              this.thisStandard.ruFileLink = response.body.ruFileLink;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'RU_PDF') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileRuPdf, this.fileRuPdf.name);
      this.adminService.uploadFiles(this.stepsControllerService.getCurrentStandard(), formData).subscribe(
        () => {
          this.adminService.getStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
            (response: any) => {
              this.thisStandard.ruPdf = response.body.ruPdf; // F+
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'EN_PDF') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileEnPdf, this.fileEnPdf.name);
      this.adminService.uploadFiles(this.stepsControllerService.getCurrentStandard(), formData).subscribe(
        () => {
          this.adminService.getStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
            (response: any) => {
              this.thisStandard.enPdf = response.body.enPdf;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'EN_DOC') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileEnDoc, this.fileEnDoc.name);
      this.adminService.uploadFiles(this.stepsControllerService.getCurrentStandard(), formData).subscribe(
        () => {
          this.adminService.getStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
            (response: any) => {
              this.thisStandard.enDoc = response.body.enDoc;
              this.thisStandard.enPdf = response.body.enPdf;
              this.thisStandard.enFileLink = response.body.enFileLink;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'EN_PPT') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileEnPpt, this.fileEnPpt.name);
      this.adminService.uploadFiles(this.stepsControllerService.getCurrentStandard(), formData).subscribe(
        () => {
          this.adminService.getStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
            (response: any) => {
              this.thisStandard.enPpt = response.body.enPpt;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
  }


  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });

  }

  deleteFileDOCX(sid, fileLink, type) {
    this.adminService.deleteTempDocxFileManually(fileLink, sid).subscribe(
      (res: any) => {
        if (type === 'RU_DOC') {
          this.thisStandard.ruDoc = null;
          this.thisStandard.ruFileLink = null;
        } else if (type === 'EN_DOC') {
          this.thisStandard.enDoc = null;
          this.thisStandard.enFileLink = null;
        }
      },
      () => {
      }
    );
  }


  fileChange(typeFile, event) {
    if (typeFile === 'RU_PPT') {
      if (event.target.files.length > 0) {
        this.fileRuPpt = event.target.files[0];
        this.isNewRuPpt = true;
      } else {
        this.fileRuPpt = null;
        this.isNewRuPpt = false;
      }
    }

    if (typeFile === 'RU_DOC') {
      if (event.target.files.length > 0) {
        this.fileRuDoc = event.target.files[0];
        this.isNewRuDoc = true;
      } else {
        this.fileRuDoc = null;
        this.isNewRuDoc = false;
      }
    }

    if (typeFile === 'RU_PDF') {
      if (event.target.files.length > 0) {
        this.fileRuPdf = event.target.files[0];
        this.isNewRuPdf = true;
      } else {
        this.fileRuPdf = null;
        this.isNewRuPdf = false;
      }
    }

    if (typeFile === 'EN_PPT') {
      if (event.target.files.length > 0) {
        this.fileEnPpt = event.target.files[0];
        this.isNewEnPpt = true;
      } else {
        this.fileEnPpt = null;
        this.isNewEnPpt = false;
      }
    }
    if (typeFile === 'EN_DOC') {
      if (event.target.files.length > 0) {
        this.fileEnDoc = event.target.files[0];
        this.isNewEnDoc = true;
      } else {
        this.fileEnDoc = null;
        this.isNewEnDoc = false;
      }
    }
    if (typeFile === 'EN_PDF') {
      if (event.target.files.length > 0) {
        this.fileEnPdf = event.target.files[0];
        this.isNewEnPdf = true;
      } else {
        this.fileEnPdf = null;
        this.isNewEnPdf = false;
      }
    }
  }

  deleteBlankFile(blank) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTBF';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.adminService.deleteBlankFromStandard(blank, this.stepsControllerService.currentStandard).subscribe(
          (response: any) => {
            if (response.status === 200) {
              const index = this.thisStandard.blanks.indexOf(blank);
              this.thisStandard.blanks.splice(index, 1);
            }
          },
          () => {
          }
        );
      }
    });
  }

  downloadFile(id) {
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }
    );
  }

  openPdfStnd(fileId: string) {
    window.open(this.apiConnectService.getPdf + fileId, '_blank');
  }

  deleteFile(fileId: string, type: string) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DO_YOU_WANT_TO_DELETE_THIS_STANDARD';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.adminService.deleteFileFromStandard(fileId, type, this.stepsControllerService.getCurrentStandard()).subscribe(
          (response: any) => {
            if (response.status === 200) {
              switch (type) {
                case 'RU_DOC': {
                  this.thisStandard.ruDoc = null;
                  break;
                }
                case 'RU_PPT': {
                  this.thisStandard.ruPpt = null;
                  break;
                }
                case 'RU_PDF': {
                  this.thisStandard.ruPdf = null;
                  break;
                }
                case 'EN_DOC': {
                  this.thisStandard.enDoc = null;
                  break;
                }
                case 'EN_PPT': {
                  this.thisStandard.enPpt = null;
                  break;
                }
                case 'EN_PDF': {
                  this.thisStandard.enPdf = null;
                  break;
                }
              }
            }
          },
          () => {
          }
        );
      }
    });
  }

  addNewBlank() {
    this.newBlanks.push(new NewBlank(null, null, null));
  }

  blanksChange(event, index: number) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData = new FormData();
      formData.append('file', file, file.name);
      this.newBlanks[index].formData = formData;
    }
  }

  saveBlank(index) {
    if (this.newBlanks[index] != null) {
      this.adminService.uploadBlank(this.stepsControllerService.getCurrentStandard(), [this.newBlanks[index]]).subscribe(
        (response) => {
          if (response.status === 200) {
            this.thisStandard.blanks.push(response.body[0]);
            this.newBlanks.splice(index, 1);
          }
        }
      );
    }
  }

  deleteBlank(key) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTB';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        if (key > -1) {
          this.newBlanks.splice(key, 1);
        }
      }
    });
  }


  goToTestingStage(): void {
    if (!this.prepareQuestionWrite()) { return; }
    const questions = this.stepTestingService.addQuestionsToStandard();
    this.stepsControllerService.goToTestingStage(this.daysForTesting, questions).takeUntil(this.destroyed$)
      .subscribe(response => {
        const standard = response.body;
        const version = savedStandardVersion(response);
        if (version != null) { standard[STANDARD_VERSION_FIELD] = version; }
        this.stepsControllerService.setCurrentStandard(standard);
        this.showTestingStart = true;
        this.stepsControllerService.stepFiveDisabled = true;
        this.stepsControllerService.stepSixDisabled = true;
        this.stepsControllerService.stepSevenDisabled = false;
        this.stepsControllerService.activeStep = TESTING_STEP;
        this.goBtnIsClicked = false;
      }, error => this.rejectQuestionWrite(error));
  }

  private prepareQuestionWrite(): boolean {
    if (this.goBtnIsClicked || this.versionConflict || this.saveFailed || this.userRemoval.pending || this.userRemoval.requiresReload) { return false; }
    this.noQValid = !this.stepTestingService.isQuestionsValid(this.stepsControllerService.getLocalUserLanguage());
    this.saveFailed = false;
    this.goBtnIsClicked = !this.noQValid;
    return !this.noQValid;
  }

  private rejectQuestionWrite(error: HttpErrorResponse): void {
    this.goBtnIsClicked = false;
    this.versionConflict = isStandardVersionConflict(error);
    this.saveFailed = !this.versionConflict;
  }

  reloadStandard(): void {
    if (this.goBtnIsClicked || this.userRemoval.pending) { return; }
    this.goBtnIsClicked = true;
    this.reloadFailed = false;
    this.adminService.getStandard(this.thisStandard.id).takeUntil(this.destroyed$).subscribe(response => {
      const standard = response.body as Standard;
      const version = savedStandardVersion(response);
      if (response.status !== RELOAD_HTTP_OK || !standard || standard.id !== this.thisStandard.id || version == null) {
        this.goBtnIsClicked = false; this.reloadFailed = true; return;
      }
      if (version != null) { standard.version = version; }
      this.acceptReloadedStandard(standard);
    }, () => {
      this.goBtnIsClicked = false;
      this.reloadFailed = true;
    });
  }

  acceptReloadedStandard(standard: Standard): void {
    this.userRemoval.reset();
    this.stepsControllerService.setCurrentStandard(standard);
    this.stepTestingService.clearQuestions();
    this.versionConflict = this.saveFailed = this.reloadFailed = this.goBtnIsClicked = false;
    this.showTestingStart = false;
    this.daysForTesting = DEFAULT_TESTING_DAYS;
    this.resetFileDraft();
    this.ngOnInit();
  }

  private resetFileDraft(): void {
    this.newBlanks = [];
    this.fileRuDoc = this.fileRuPpt = this.fileRuPdf = null;
    this.fileEnDoc = this.fileEnPpt = this.fileEnPdf = null;
    this.isNewRuDoc = this.isNewRuPpt = this.isNewRuPdf = false;
    this.isNewEnDoc = this.isNewEnPpt = this.isNewEnPdf = false;
    this.isUploadDisabled = false;
  }

  ngOnDestroy(): void {
    this.userRemoval.ngOnDestroy();
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  deleteUserFromStnd(user: StandardFamiliarizationUser): void {
    this.userRemoval.remove(this.thisStandard, user, users => this.acceptAssignedUsers(users));
  }

  acceptAssignedUsers(users: StandardFamiliarizationUser[]): void {
    this.tableUsers = users;
    this.showTable = !!users.length;
  }

  shBlock(s) {
    switch (s) {
      case 'sau':
        this.showAddUser = !this.showAddUser;
        break;
      case 'sct':
        this.showCreateTesting = !this.showCreateTesting;
        break;
      case 'scl':
        this.showChangeLog = !this.showChangeLog;
        break;
      case 'sut':
        this.showUserTable = !this.showUserTable;
        break;
      case 'sfab':
        this.showFilesAndBlanks = !this.showFilesAndBlanks;
        break;
    }
  }

  // TRANSLATE QUESTIONS REQUEST
  sendTranslateQuestionsRequest(): void {
    if (!this.prepareQuestionWrite()) { return; }
    const questions = this.stepTestingService.addQuestionsToStandard();
    const standard = this.thisStandard;
    if (standard.language === STANDARD_QUESTION_LANGUAGE_RUSSIAN) { questions.english = null; }
    if (standard.language === STANDARD_QUESTION_LANGUAGE_ENGLISH) { questions.russian = null; }
    this.stepsControllerService.addQuestionsToStandardHead(standard.id, questions)
      .concatMap(() => this.stepsControllerService.sendTranslateQuestionsRequest(standard.id))
      .takeUntil(this.destroyed$).subscribe(() => {
        standard.inTranslation = true;
        standard.translatedQuestions = false;
        this.goBtnIsClicked = false;
      }, error => this.rejectQuestionWrite(error));
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-six/opst-step-six.component.ts